import { render, staticRenderFns } from "./keywords-calculation-config.vue?vue&type=template&id=f350a2e8&"
import script from "./keywords-calculation-config.vue?vue&type=script&lang=js&"
export * from "./keywords-calculation-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports